import {RankedModeTypes} from '../../../../shared/GameEnums'
import {setElementOnClick} from '../ui_utils/DomUtils'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {ClientUserState} from '../ClientUserState'

export class UILeaderboardSidebarTabsController {
    private readonly onChangeRankedModeType: (modeType: RankedModeTypes) => void
    private readonly tabElements: HTMLAnchorElement[] = []
    private enabledRankModeTypes: RankedModeTypes[]

    constructor(onChangeRankedModeType: (modeType: RankedModeTypes) => void) {
        this.onChangeRankedModeType = onChangeRankedModeType
        this.tabElements.push(document.getElementById(RankedModeTypes[RankedModeTypes.Classic1v1]) as HTMLAnchorElement)
        this.tabElements.push(document.getElementById(RankedModeTypes[RankedModeTypes.Classic4P]) as HTMLAnchorElement)
        this.tabElements.push(document.getElementById(RankedModeTypes[RankedModeTypes.CitiesAndKnights4P]) as HTMLAnchorElement)
        this.addSidebarEventHandlers()

        void this.initRush4PTab()
    }

    private async initRush4PTab() {
        await ClientUserState.waitUntilFresh
        const rush4PTab = document.getElementById(RankedModeTypes[RankedModeTypes.Rush4P]) as HTMLAnchorElement | null
        if(rush4PTab && ClientUserState.abTests?.RANKED_RUSH_4P === 'VISIBLE_RANKED_RUSH_4P') {
            rush4PTab.style.display = ''
            this.tabElements.push(rush4PTab)
            this.addSidebarEventHandlerForElement(rush4PTab)
        }
    }

    private addSidebarEventHandlers() {
        for(const sidebarButton of this.tabElements) {
            this.addSidebarEventHandlerForElement(sidebarButton)
        }
    }

    private addSidebarEventHandlerForElement(sidebarButton: HTMLAnchorElement) {
        setElementOnClick(sidebarButton, () => {
            const rankedModeType = RankedModeTypes[sidebarButton.id]
            if(this.enabledRankModeTypes.indexOf(rankedModeType) === -1) return
            this.onChangeRankedModeType(rankedModeType)
            if(!UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return
            const inputBtn = sidebarButton.children[0] as HTMLInputElement
            inputBtn.checked = true
        }, true)
    }

    highlightTab(tab: RankedModeTypes) {
        for(const sidebarButton of this.tabElements) {
            const rankedModeType = RankedModeTypes[sidebarButton.id]
            if(rankedModeType === tab) {
                sidebarButton.classList.add('active')
            } else {
                sidebarButton.classList.remove('active')
            }
        }
    }

    setEnabledRankedModeTypes(rankedModeTypes: RankedModeTypes[]) {
        this.enabledRankModeTypes = rankedModeTypes
        for(const sidebarButton of this.tabElements) {
            const rankedModeType = RankedModeTypes[sidebarButton.id]
            if(rankedModeTypes.indexOf(rankedModeType) === -1) {
                sidebarButton.classList.add('disabled')
                if(rankedModeType === RankedModeTypes.Rush4P) {
                    sidebarButton.style.display = 'none'
                }
            } else {
                sidebarButton.classList.remove('disabled')
            }
        }
    }
}
